import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ProductDescriptionParsedField } from './ProductDescriptionParsedField'

export const ProductDescriptionManufacturerDetails: FC<{
  manufacturerDetails: string
}> = ({ manufacturerDetails }) => {
  return (
    <>
      <h3 className="mt-5 text-s font-medium">
        <FormattedMessage id="general.label.manufacturer" />
      </h3>
      <ProductDescriptionParsedField
        className="not-prose"
        field={manufacturerDetails}
      />
    </>
  )
}
